const SeverityPriorityEnum: Record<string, number> = {
  HEALTHY: 0,
  INFORMATIONAL: 10,
  SCANFAILURE: 20,
  MINOR: 30,
  MAJOR: 40,
  CRITICAL: 50,
};

type Severity = keyof typeof SeverityPriorityEnum;

export default Severity;
export {SeverityPriorityEnum};
